import { useMemo } from 'react';
import { CardTypesEnum, useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { ReactivationPlan } from '@/modules/employer/components/EmployerReactivation/types';

const QUERY_KEY = 'EmployerReactivationEligiblePlans';

export const useGetReactivationEligiblePlans = (organizationId?: string) => {
  const { data, isLoading, refetch } = useQuery(
    [QUERY_KEY, organizationId],
    () => api.get(API_URL.PLANS_ORGANIZATIONS_REACTIVATION_ELIGIBLE_BY_ORGANIZATION_ID(organizationId || '')),
    {
      enabled: !!organizationId,
      retry: 0,
      cacheTime: 0,
      staleTime: 0,
    }
  );

  const plans = useMemo<ReactivationPlan[]>(() => {
    return (data?.data || []).map((plan) => ({
      id: `${plan.id}`,
      name: plan.name?.name || '',
      validFrom: plan.plan_year?.valid_from || '',
      validTo: plan.plan_year?.valid_to || '',
      type: plan.account_type?.account_type as unknown as CardTypesEnum,
      isPlanLevelFunding: plan.plan_account_funding_config?.is_plan_level_funding?.is_plan_level_funding,
    }));
  }, [data]);

  return {
    plans,
    isLoading,
    refetch,
  };
};
